module.exports = __webpack_public_path__ + "img/Header-2-2.b2a5bf7e.webp";